import { useRef } from 'react';
import type { AriaTextFieldProps } from 'react-aria';
import { useTextField } from 'react-aria';



export interface TextAreaProps extends AriaTextFieldProps<HTMLTextAreaElement> {
	required?: boolean,
	rounded?: boolean,
}


export const TextArea = (props: TextAreaProps) => {
	const { required = false, rounded = false, ...otherProps } = props;
	
	let ref = useRef<HTMLTextAreaElement>(null);
	
	let { labelProps, inputProps, descriptionProps, errorMessageProps } = useTextField({ ...otherProps, inputElementType: 'textarea' }, ref);

	return (
		<div className='component-text-area'>

			<label {...labelProps} className='text-area-label'>
				{props.label} {required ? <span>*</span> : ''}
			</label>
			
			<textarea {...inputProps} ref={ref} className={`text-area-input${rounded ? ' rounded' : ''}`} />
		
			{props.errorMessage && typeof props.errorMessage === 'string' &&
				<div {...errorMessageProps} className={`text-area-error${rounded ? ' rounded' : ''}`}>
					{props.errorMessage}
				</div>}

			{props.description && 
				<div {...descriptionProps} className='text-area-description'>
					{props.description}
				</div>}
		</div>
	)
}